import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        //backend: process.env.VUE_APP_BACKEND_URL,
        desktop: false,
        backend: 'https://api.swiset.com/api',
        //backend: 'http://localhost:8080/api',
        paypalSubscriptionsScript: 'https://www.paypal.com/sdk/js?client-id=ATafAIbtL5aO_30PailV-bTi3xhijOWQJkJEvU4_5YQeyl7Tbr4Ua-djoTVe8FJ-7ydl7imoR9MC950u&vault=true',
        currentUser: {
            id: 0,
            firstName: '',
            email: '',
            username: '',
        },
    },
    actions: {
    },
    mutations: {
        setDesktopContext(state, desktop) {
            state.desktop = desktop;
        },
        setCurrentUser(state, user) {
            state.currentUser.id = user.id;
            state.currentUser.firstName = user.firstName;
            state.currentUser.email = user.email;
            state.currentUser.username = user.login;
        },
    }
});
